module.exports = __webpack_public_path__ + "media/images/sites/health/favicon-192x192-928b017ceace02ea327c2b3a7184b9a0.png";